import { serviceGo } from "@/utils/request";

// 积分类型接口
export interface GamePoint {
  id: number
  game_id: number
  point_name: string
  min_value: number
  max_value: number
  default_value: number
}

// 获取游戏的所有积分类型
export async function getGamePoints(gameId: number): Promise<{ data: GamePoint[] }> {
  const response = await serviceGo.get<{ data: GamePoint[] }>('/api_v2/game-points', {
    params: { game_id: gameId }
  })
  return response.data
}

// 创建积分类型
export async function createGamePoint(data: Partial<GamePoint>): Promise<GamePoint> {
  const response = await serviceGo.post('/api_v2/game-points', data)
  return response.data
}

// 更新积分类型
export async function updateGamePoint(id: number, data: Partial<GamePoint>): Promise<GamePoint> {
  const response = await serviceGo.put(`/api_v2/game-points/${id}`, data)
  return response.data
}

// 删除积分类型
export async function deleteGamePoint(id: number): Promise<void> {
  await serviceGo.delete(`/api_v2/game-points/${id}`)
}
